import TableCell from '@mui/material/TableCell';
import React from 'react';
import { REFUND_STATUSES } from '@/utility';

const RefundStatusCell = ({ refund }) => {
  return (
    <TableCell>
      {refund && refund.refund_status && (
        <span>
          <a
            style={{
              color:
                refund.refund_status === REFUND_STATUSES.COMPLETED
                  ? ''
                  : '#000000',
              cursor: 'auto',
            }}>
            {refund.refund_status ? refund.refund_status : 'N/A'}
          </a>
          <br />
          <span style={{ fontSize: '12px' }}>
            {refund.refund_sub_status || 'N/A'}
          </span>
        </span>
      )}
    </TableCell>
  );
};

export default RefundStatusCell;
